import {
  getSessionData,
  getVersionedCallbackUrl,
  redirectToWebform,
} from "@repo/shared-utils/common-utils";
import { isOpenInApp } from "@repo/shared-utils/pwa-utils";
import { solarInsert, type ISolarInsertApiRequest } from "@repo/connection-manager";
import type { SSORedirectHandler } from "../types/SSO.types";
import { PDP_DETAILS, WHEELS_OFFER } from "../../../api-client/src/constants/util";

type SolarJourneyName = "SRL_NTB" | "SRL_ETB" | "SUL_NTB" | "SUL_ETB" | "SUCL_NTB" | "SUCL_ETB";
type SolarProdCode = "SRL" | "SUL" | "SUCL";

const PRODUCT_CODE: SolarProdCode[] = ["SRL", "SUL", "SUCL"];
const JOURNEY_NAME: SolarJourneyName[] = [
  "SRL_NTB",
  "SRL_ETB",
  "SUL_NTB",
  "SUL_ETB",
  "SUCL_NTB",
  "SUCL_ETB",
];
const DEFAULT_JOURNEY_NAME: SolarJourneyName = "SRL_NTB";

type SolarInsertData = Partial<ISolarInsertApiRequest> & {
  id?: string;
};

const SOLAR_HANDLER_LOG = "[SolarSSO][Handler]";

export const solarHandler: SSORedirectHandler = async (data) => {
  const { mobileNo, custType } = await getSessionData();
  const solarInsertData = (data.data?.solarInsert ?? {}) as SolarInsertData;
  const applicationID = solarInsertData.id;

  console.info(`${SOLAR_HANDLER_LOG} start`, {
    hasApplicationId: Boolean(applicationID),
    mappingModule: data.mapping?.ssoModule,
    mobileNoPresent: Boolean(mobileNo),
    payload: solarInsertData,
  });

  let response: { id?: string } | null = null;

  if (!applicationID) {
    console.info(`${SOLAR_HANDLER_LOG} calling solarInsert`, {
      journeyName: solarInsertData.journeyName ?? DEFAULT_JOURNEY_NAME,
      sourceSystem: isOpenInApp() ? "3in1App" : "3in1Web",
    });

    response = await solarInsert({
      ...solarInsertData,
      mobileNo,
      custType,
      journeyName: solarInsertData.journeyName ?? DEFAULT_JOURNEY_NAME,
      eventCode: WHEELS_OFFER,
      eventName: PDP_DETAILS,
      prodName: PRODUCT_CODE[0],
      apiVersion: "P.11.1.4",
      srcChannel: "3in1",
      sourceSystem: isOpenInApp() ? "3in1App" : "3in1Web",
    });

    console.info(`${SOLAR_HANDLER_LOG} solarInsert response`, {
      id: response?.id,
    });
  } else {
    console.info(`${SOLAR_HANDLER_LOG} skipping hlInsert because applicationID already exists`, {
      applicationID,
    });
  }

  const callbackUrl = await getVersionedCallbackUrl(data.mapping);
  const finalApplicationId = response?.id ?? applicationID;

  console.info(`${SOLAR_HANDLER_LOG} redirectToWebform`, {
    callbackUrl: callbackUrl.toString(),
    applicationID: finalApplicationId,
    mobileNo,
    product: PRODUCT_CODE[0],
  });

  await redirectToWebform(callbackUrl.toString(), {
    applicationID: finalApplicationId,
    mobileNo,
    product: PRODUCT_CODE[0],
  });

  console.info(`${SOLAR_HANDLER_LOG} complete`);
};
